import { InfoBarCustomAction } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { getComposeHostItemIndex, lazyDeinitializeAddinsForItem } from 'owa-addins-core';
import showModifyProtectionDialog from 'owa-mail-protection/lib/utils/rms/modifyProtectionInfoBarCustomAction';
import { cmpEncryptionChangePermissions } from 'owa-mail-protection/lib/utils/rms/modifyProtectionInfoBarCustomAction.locstring.json';
import { ComposeViewState } from 'owa-mail-compose-store';

export default function createModifyProtectionInfoBarCustomAction(
    composeViewState: ComposeViewState,
    targetWindow: Window
): InfoBarCustomAction {
    let { protectionViewState, composeId, bodyType } = composeViewState;
    return {
        text: loc(cmpEncryptionChangePermissions),
        action: () => {
            showModifyProtectionDialog(
                protectionViewState,
                composeViewState,
                bodyType,
                targetWindow
            ).then(protectionApplied => {
                protectionApplied &&
                isFeatureEnabled('rp-addins') && // add-ins need to be deinitialized, don't support IRM/SMIME
                    lazyDeinitializeAddinsForItem.import().then(deinitializeAddinsForItem => {
                        deinitializeAddinsForItem(getComposeHostItemIndex(composeId));
                    });
            });
        },
    };
}
